<template>
  <div class="cms-youtube-cid">
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialog(false)"
      @open="open"
    >
      <el-form label-position="top">
        <el-form-item label="Name" prop="name">
          <el-input type="text" v-model="user.name" clearable />
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input type="text" v-model="user.email" clearable />
        </el-form-item>
        <el-form-item label="User" prop="cid_user">
          <el-select v-model="user.user_id" clearable filterable>
            <el-option
                v-for="c in cid_users"
                :key="c.id"
                :value="c.id"
                :label="`${c.name}`"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Asset Labels" prop="asset_label">
          <el-select v-model="user.asset_label_id" clearable filterable>
            <el-option
                v-for="c in asset_labels"
                :key="c.id"
                :value="c.id"
                :label="`${c.name}`"
            ></el-option>
          </el-select>
        </el-form-item>
        <br><hr><br>
        <el-form-item class="client-asset-labels">
          <el-button @click="addClientAssetLabels">Add Client</el-button>
          <small class="ml10">(You can add maximum 3 clients)</small>
        </el-form-item>
        <div v-for="(client) in user.clients" :key="client.key">
          <el-select class="mt10" v-model="client.id" clearable filterable>
            <el-option
                v-for="c in asset_labels"
                :key="c.id"
                :value="c.id"
                :label="`${c.name}`"
            ></el-option>
          </el-select>
          <el-button class="mt10" @click.prevent="removeClientAssetLabels(client)">Delete</el-button>
        </div>
        <el-form-item  prop="active">
          <el-checkbox label="Active" v-model="active"></el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      active: false
    }
  },
  computed: {
    ...mapState('youtubeUsers', ['dialog', 'loading', 'user', 'cid_users', 'asset_labels', 'client_asset_labels']),
    dialogTitle: function() {
      if (
          typeof this.user.id !== 'undefined' &&
          this.user.id !== null
      )
        return 'Edit user'
      else {
        return 'Insert user'
      }
    },
  },

  methods: {
    ...mapActions('youtubeUsers', ['insert', 'update', 'readCidUsers', 'readAssetLabels']),
    ...mapMutations('youtubeUsers', ['setDialog', 'setClientAssetLabels']),

    submit() {
      this.user.active = (this.active == true) ? 1 : 0;

      if (typeof this.user.id !== 'undefined' && this.user.id !== null)
      {
        this.update(this.user.id)
      }
      else {
        this.insert()
      }
    },

    open(){
      if(this.user.active == 1) this.active=true
      else this.active=false
      this.readCidUsers()
      this.readAssetLabels()
    },

    addClientAssetLabels() {
      let clientAssetLabels = this.user.clients
      if (clientAssetLabels && clientAssetLabels.length === 3) return

      clientAssetLabels.push({key: new Date().getTime()})
      this.setClientAssetLabels(clientAssetLabels)
    },

    removeClientAssetLabels(link) {
      let clientAssetLabels = this.user.clients
      const index = clientAssetLabels.indexOf(link);

      if (index !== -1) {
        clientAssetLabels.splice(index, 1);
      }
      this.setClientAssetLabels(clientAssetLabels)
    },
  }
}
</script>

<style scoped lang="scss">

</style>
